import { SelectionModel } from '@angular/cdk/collections';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ITableDelegate, ITableOptions } from '@modeso/aumico-lib-core-fe';
import { IAccountingBasisExtendedDTO } from '@modeso/types__aumico-lib-settings-be';
import { Observable } from 'rxjs';
import { getLocalizationFromAsyncPipe } from '../../utils/localizationUtils';
import { getDebug, getTag } from './../../utils/debugUtil';
import { I18NextService } from 'angular-i18next';

const filename =
    'projects/aumico-lib-settings-fe/src/lib/components/accounting-basis-list/accounting-basis-list.component.ts';
const debug = getDebug(filename);
const TAG = getTag(filename);
@Component({
    // tslint:disable-next-line: component-selector
    selector: 'aumico-settings-accounting-basis-list',
    templateUrl: './accounting-basis-list.component.html',
    styleUrls: ['./accounting-basis-list.component.scss'],
})
export class AccountingBasisListComponent implements OnInit, ITableDelegate {
    public options: ITableOptions;
    private rawData: IAccountingBasisExtendedDTO[];

    @Input()
    public set data(items: IAccountingBasisExtendedDTO[]) {
        this.rawData = items;
    }
    public get data(): IAccountingBasisExtendedDTO[] {
        return this.rawData;
    }

    public errorMessage: Observable<HttpErrorResponse>;

    @Input() languages: string[] = ['de-ch', 'en-us'];

    @Output()
    public editPressed = new EventEmitter<string>();

    constructor(private i18nextService: I18NextService) {
        this.prepareFields();
    }

    ngOnInit() {
        this.prepareFields();
    }

    private async prepareFields() {
        this.options = {
            columns: [
                {
                    name: await getLocalizationFromAsyncPipe(
                        this.i18nextService,
                        'aumico_settings_accountingbasis_id',
                    ),
                    type: 'text',
                    property: '_id',
                },
                {
                    name: await getLocalizationFromAsyncPipe(
                        this.i18nextService,
                        'aumico_settings_accountingbasis_version',
                    ),
                    type: 'text',
                    property: 'version',
                },
                {
                    name: await getLocalizationFromAsyncPipe(
                        this.i18nextService,
                        'aumico_settings_accountingbasis_owner',
                    ),
                    type: 'text',
                    property: 'owner',
                },
                {
                    name: await getLocalizationFromAsyncPipe(
                        this.i18nextService,
                        'aumico_settings_accountingbasis_name',
                    ),
                    type: 'text',
                    property: 'name',
                },
                {
                    name: await getLocalizationFromAsyncPipe(
                        this.i18nextService,
                        'aumico_settings_accountingbasis_text',
                    ),
                    type: 'translated-text',
                    property: 'text',
                },

                {
                    name: await getLocalizationFromAsyncPipe(this.i18nextService, 'aumico_button_edit'),
                    type: 'button',
                    property: '_id',
                    action: 'edit',
                },
            ],
        };
    }

    public onRowButtonClicked(item: string, action?: string): void {
        debug(`1 Row with Id ${item} clicked for action ${action}`);

        if (action === 'edit') {
            this.editPressed.emit(item);
        }
    }

    onMenuItemClick(action: string, selectedRows: SelectionModel<any>) {
        debug('onMenuItemClick', action, selectedRows);
    }
}
